export const firstAndLastNameToTitle = (obj) => obj
  ? ({ ...obj, title: obj.firstName + ' ' + obj.lastName })
  : obj;

export const toOption = ({ id, title }) => ({
  id,
  label: title,
  value: title,
});

export const formatToObjectOfOptions = (obj) => {
  return Object.keys(obj).reduce((newObj, key) => {
    newObj[key] = obj[key] ? toOption(obj[key]) : obj[key];

    return newObj;
  }, {});
};

const formatDataForSelect = (options) => options.filter(Boolean).map(toOption);

export default formatDataForSelect;
